import {
  ApplyFreeTrialRequest,
  ApplyFreeTrialResponse,
  CreateShareTokenWithConsentResponse,
  DetourFreeTrialRecitationRequest,
  FreeTrialContextItem,
  FreeTrialQuotaItem,
  FreeTrialRecitationResult,
  FreeTrialSharedInfo,
  FreeTrialStatusItem,
  ReportFreeTrialStepProgressRequest,
} from '../../../constants/types/free-trial/type';
import instance from '../../axios/utils.ts/instance';

/**
 * 내 체험 상태 조회 (홈 카드 분기)
 */
export const getFreeTrialStatus = async () => {
  const response = await instance.get<FreeTrialStatusItem>(
    `/v1/free-trial/my-status`,
  );

  return response.data;
};

/**
 * 남은 신청 횟수 조회
 */
export const getFreeTrialQuota = async () => {
  const response = await instance.get<FreeTrialQuotaItem>(
    `/v1/free-trial/application-quota`,
  );

  return response.data;
};

/**
 * 무료체험 신청
 */
export const applyFreeTrial = async (request: ApplyFreeTrialRequest) => {
  const response = await instance.post<ApplyFreeTrialResponse>(
    `/v1/free-trial/applications`,
    request,
  );

  return response.data;
};

/**
 * 체험 페이지 부트스트랩 조회
 */
export const getFreeTrialContext = async (linkToken: string) => {
  const response = await instance.get<FreeTrialContextItem>(
    `/v1/free-trial/t/${linkToken}`,
  );

  return response.data;
};

/**
 * 체험 단계 진행 보고
 */
export const reportFreeTrialStepProgress = async (
  request: ReportFreeTrialStepProgressRequest,
) => {
  const { linkToken, step } = request;

  const response = await instance.post(
    `/v1/free-trial/t/${linkToken}/progress`,
    { step },
  );

  return response.data;
};

/**
 * 연습 진입 보고
 */
export const reportFreeTrialRecitationPractice = async (linkToken: string) => {
  const response = await instance.post(
    `/v1/free-trial/t/${linkToken}/practice`,
  );

  return response.data;
};

/**
 * [dev 전용] AI 인증 판정 우회 (FE 통합 테스트용)
 */
export const detourFreeTrialRecitation = async (
  request: DetourFreeTrialRecitationRequest,
) => {
  const { linkToken, passed } = request;

  const response = await instance.post(
    `/v1/free-trial/t/${linkToken}/dev-judge`,
    { passed },
  );

  return response.data;
};

/**
 * AI 인증 결과 조회 (완료 버튼 -> 결과 화면 전환용)
 */
export const getFreeTrialRecitationResult = async (linkToken: string) => {
  const response = await instance.get<FreeTrialRecitationResult>(
    `/v1/free-trial/t/${linkToken}/recitation-result`,
  );

  return response.data;
};

/**
 * 결과 공유 동의 + 공유 토큰 발급
 */
export const createShareTokenWithConsent = async (linkToken: string) => {
  const response = await instance.post<CreateShareTokenWithConsentResponse>(
    `/v1/free-trial/t/${linkToken}/share-consent`,
  );

  return response.data;
};

/**
 * 공유 랜딩 공개 조회
 */
export const getFreeTrialSharedInfo = async (shareToken: string) => {
  const response = await instance.get<FreeTrialSharedInfo>(
    `/v1/free-trial/share/${shareToken}`,
  );

  return response.data;
};
